'use client';

import { PageGrid, PageGridItem } from 'corgi/common/components/PageGrid';
import RegistrationForm from 'corgi/registration-form/components/RegistrationForm';

import { commonGridStyles } from '@components/signup/body/styles';
import type { RegistrationFormProps } from '@local-types/signup/props';

interface RegistrationBodyProps {
  registrationFormProps: RegistrationFormProps;
}

const RegistrationBody = ({ registrationFormProps }: RegistrationBodyProps) => (
  <PageGrid {...commonGridStyles} py={['sp_20', 'sp_24', null, 'sp_32']}>
    <PageGridItem width={[1, 3 / 4, '400px', '448px']} maxWidth={['432px', null, '448px']}>
      <RegistrationForm {...registrationFormProps} />
    </PageGridItem>
  </PageGrid>
);

export default RegistrationBody;
